export default __webpack_public_path__ + "static/media/house-blocks.ad88ec36.jpg";